import signingAxios from './signingAxiosService';

const BASE = 'public/signing';

export class SigningService {
    constructor(token) {
        this._authHeader = token ? { Authorization: `Bearer ${token}` } : {};
    }


    startSession = (signerProcessId) =>
        signingAxios.post(`${BASE}/${signerProcessId}/start-session`);

    getSigningInfo = (signerProcessId) =>
        signingAxios.get(`${BASE}/${signerProcessId}`, { headers: this._authHeader });

    initiateSign = (signerProcessId) =>
        signingAxios.post(`${BASE}/${signerProcessId}/sign`, {}, { headers: this._authHeader });

    cancelSigning = (signerProcessId) =>
        signingAxios.delete(`${BASE}/${signerProcessId}`, { headers: this._authHeader });

    submitNationalId = (signerProcessId, nationalId) =>
        signingAxios.post(`${BASE}/${signerProcessId}/national-id`, { nationalId }, { headers: this._authHeader });
}
